<template>
	<div class="input-wrapper">
		<label v-if="labelText"
			:id="uniqueLabel"
		   	class="label form-label">
			{{ labelText }}
		</label>
		<select id="select"
				v-model="selected"
				:aria-labelledby="uniqueLabelUsingAria"
				class="form-select"
				:class="{
				'input--error': v$.selected.$dirty && selected === '',
			}"
				@change="$emit('selected', selected)"
				@blur="handleClick">
			<option 
					v-if="disablePlaceholder"
					id="placeholder"
					value=""
					disabled>
				Please select
			</option>

			<template v-if="hasSplitValueAndText">
				<option v-for="option in options"
					:key="option.value"
					:value="option.value"
					:selected="(selected && selected === option.value.toString() ? 'selected': null)">
					{{ option.text }}
				</option>
			</template>
			<template v-else>
				<option v-for="option in options"
					:key="option"
					:value="option"
					:selected="(selected && selected === option.toString() ? 'selected': null)">
					{{ option }}
				</option>
			</template>
		</select>
		<transition name="fade">
			<p v-if="v$.selected.$error"
			   class="error-text">
				{{ errorTextComputed }}
			</p>
		</transition>
	</div>
</template>

<script>
	import { useVuelidate } from '@vuelidate/core';
	import { required } from '@vuelidate/validators';
	import { cleanStrForElemId } from '../../../lib/utils/helpers';

	export default {
		props: {
			options: {
				type: Array,
				default: function () {
					return [];
				},
			},
			labelText: {
				type: String,
				default: '',
			},
			errorText: {
				type: String,
				default: '',
			},
			disablePlaceholder: {
				type: Boolean,
				default: false,
			},
			prefillSelect: {
				type: String,
				default: '',
			}
		},
		emits: ['selected'],
		data() {
			return {
				selected: '',
				placeholder: 'Please select',
				v$: useVuelidate(),

			};
		},
		computed: {
			errorTextComputed() {
				return this.errorText ? this.errorText : 'Please select';
			},

			hasSplitValueAndText() {
				return (this.options && this.options[0]?.value && this.options[0].text ? true : false);
			},
			uniqueLabel() {
				return cleanStrForElemId(this.labelText) + '-label';
			},
			uniqueLabelUsingAria() {
				if (!this.labelText && this.$attrs['aria-labelledby']) {
					return cleanStrForElemId(this.$attrs['aria-labelledby']);
				} else if (this.labelText) {
					return this.uniqueLabel;
				} else {
					return null;
				}
			}
		},
		methods: {
			handleClick() {
				this.v$.selected.$dirty = true;
			},
		},
		validations() {
			return {
				selected: {
					required,
					$autoDirty: true,
				},
			};
		},
		mounted() {
			if (this.prefillSelect) {
				this.selected = this.prefillSelect;
				this.$emit("selected", this.selected);
			}
		}
	};
</script>

<style scoped lang="scss">
	// TODO: Refactor this to be in a .SCSS file
	// This is copied in multiple places across main site and journeys as well, lots of discrepancies now
	.dropdown {
		border-radius: 4px;
		border-style: solid;
		border-color: #d9dadc;
		border-width: 1px;
		transition: border-color 0.2s ease;
		height: 50px;
		width: 300px;
		padding-left: 15px;
		font-size: 15px;
		background: url('/assets/images/downArrow.svg') no-repeat;
		background-position: calc(100% - 0.75rem) center !important;
		-moz-appearance: none !important;
		-webkit-appearance: none !important;
		appearance: none !important;
		padding-right: 2rem !important;

		&:focus {
			border-color: #40474f;
			outline: none;
			border-width: 1px;
		}
	}

	#placeholder {
		color: #a6a8ac;
	}
</style>
